/**
 * TR-714 GraphQL documents not always present in the gateway schema used for codegen.
 * Import these from `@app/graphql` (re-exported in index.ts) instead of relying on codegen alone.
 */
import { gql } from '@apollo/client'

export const DeleteCompetitionDocument = gql`
  mutation DeleteCompetition($competitionId: ID!) {
    deleteCompetition(competitionId: $competitionId)
  }
`

export const JoinTipsterCompetitionDocument = gql`
  mutation JoinTipsterCompetition($competitionId: ID!) {
    joinTipsterCompetition(competitionId: $competitionId) {
      id
      takenSlots
      remainingSlots
      isOpen
    }
  }
`

export const GetCompetitionTipsterLeaderboardDocument = gql`
  query GetCompetitionTipsterLeaderboard(
    $competitionId: ID!
    $limit: Float
    $offset: Float
    $snapshotId: String
  ) {
    competitionTipsterLeaderboard(
      competitionId: $competitionId
      limit: $limit
      offset: $offset
      snapshotId: $snapshotId
    ) {
      top {
        rank
        tipsterId
        displayName
        avatarUrl
        profit
        winRate
        roi
        totalTips
        won
        lost
      }
      entries {
        rank
        tipsterId
        displayName
        avatarUrl
        profit
        winRate
        roi
        totalTips
        won
        lost
      }
      totalCount
      hasNextPage
      snapshotId
      minTipsThreshold
    }
  }
`
